<template>
    <div class="container">
        <div class="title-container">
            <span>{{ $t('contact.page.title') }}</span>
            <ReglePastille cle="contact.definition" />
        </div>
        <div class="content-container">
            <component :is="getComponent" />
        </div>
    </div>

    <BottomNavigation
        :back="back"
        :cancel="cancel"
        :confirm="request"
        :confirmButtonDisabled="!isValid"
        :first="step === 0"
        :last="isLastStep"
        :next="next"
    />
    <WaitingModal v-if="isSending" :text="$t('contact.page.message.sending')"></WaitingModal>
    <SuccessModal v-if="isSuccess" :subtitle="$t('contact.page.message.sent')" :title="''" @click="cancel" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BottomNavigation from '@/components/layout/BottomNavigation.vue';
import { CONTACT } from '../store/mutation-types';
import { store } from '@/plugins/store';
import { ContactActions } from '../store/action-types';
import WaitingModal from '@/components/ui-components/WaitingModal.vue';
import SuccessModal from '@/components/ui-components/SuccessModal.vue';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'ContactPage',
    components: {   BottomNavigation, SuccessModal, WaitingModal, ReglePastille },
    computed: {
        selectedSite() {
            return store.state.contactState.site;
        },
        step(): number {
            return store.state.contactState.step;
        },
        isValid(): boolean {
            return store.getters['contactState/isContactFormValid'];
        },
        isSending(): boolean {
            return store.state.contactState.isSendingMessage;
        },
        isSuccess(): boolean {
            return store.state.contactState.isSuccess;
        },
        getComponent() {
            return store.getters['contactState/getCurrentStep'];
        },
        isLastStep(): boolean {
            return store.getters['contactState/isLastStep'];
        },
    },
    methods: {
        cancel() {
            this.$router.back();
        },
        next() {
            store.commit(`contactState/${CONTACT.NEXT_STEP}`);
        },
        back() {
            store.commit(`contactState/${CONTACT.PREVIOUS_STEP}`);
        },
        request() {
            store.dispatch(`contactState/${ContactActions.SEND_MESSAGE}`);
        },
    },
    mounted() {
        store.commit(`contactState/${CONTACT.RESET}`);
    },
    unmounted() {
        store.commit(`siteList/${SITE_LIST.RESET}`);
    },
});
</script>

<style scoped>
.title-container {
    color: var(--color-principal);
    font-size: var(--font-size-large);
    font-weight: var(--font-weight-600);
}

.container {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 24px 24px 0 24px;
}

.content-container {
    margin-top: 8px;
}
</style>
